// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgTooltipQuestion16 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				xmlns="http://www.w3.org/2000/svg"
				width={size}
				height={size}
				viewBox="0 0 16 16"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path d="M13.3335 1.33398H2.66683C2.3135 1.33398 1.9735 1.47398 1.72683 1.72732C1.4735 1.97398 1.3335 2.31398 1.3335 2.66732V10.6673C1.3335 11.0207 1.4735 11.3607 1.72683 11.6073C1.9735 11.8607 2.3135 12.0007 2.66683 12.0007H5.3335L8.00016 14.6673L10.6668 12.0007H13.3335C13.6868 12.0007 14.0268 11.8607 14.2735 11.6073C14.5202 11.354 14.6668 11.0207 14.6668 10.6673V2.66732C14.6668 2.31398 14.5268 1.97398 14.2735 1.72732C14.0268 1.47398 13.6868 1.33398 13.3335 1.33398ZM6.70016 4.02732C7.06016 3.78732 7.5335 3.66732 8.12683 3.66732C8.7535 3.66732 9.2535 3.80732 9.6135 4.08065C9.9735 4.36065 10.1535 4.73398 10.1535 5.20065C10.1535 5.49398 10.0535 5.75398 9.86016 6.00065C9.66683 6.24065 9.4135 6.42732 9.10683 6.56732C8.9335 6.66732 8.82016 6.76732 8.76016 6.88065C8.70016 7.00065 8.66683 7.14732 8.66683 7.33398H7.3335C7.3335 7.00065 7.40016 6.77398 7.52683 6.61398C7.66683 6.45398 7.8935 6.26732 8.24016 6.05398C8.4135 5.96065 8.5535 5.84065 8.66683 5.69398C8.76016 5.55398 8.8135 5.38732 8.8135 5.20065C8.8135 5.00065 8.7535 4.85398 8.6335 4.74065C8.5135 4.62065 8.3335 4.56732 8.12683 4.56732C7.94683 4.56732 7.80016 4.61398 7.66683 4.70732C7.56016 4.80065 7.4935 4.94065 7.4935 5.12732H6.18016C6.14683 4.66732 6.3335 4.26732 6.70016 4.02732ZM7.3335 9.33398V8.00065H8.66683V9.33398H7.3335Z" />
			</Svg>
		);
	}
);
SvgTooltipQuestion16.defaultProps = {
	size: 16,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgTooltipQuestion16;
